import { ax } from 'src/client'
import { removeFalsyProperties } from 'src/utils'
import * as serviceURLS from './serviceURLS'

export const getEtps = (params) => {
  const paramsToSend = removeFalsyProperties({
    // pagination
    limit: params.rowsPerPage,
    offset: params.offset,
    descending: params.descending,
    sort_by: params.sortBy,
    // filters
    client_name: params.clientName,
    client_country: params.clientCountry,
    isin: params.isin,
    created_at_from: params.createdAtFrom,
    created_at_to: params.createdAtTo,
    amount_from: params.amountFrom,
    amount_to: params.amountTo,
    state: params.states
  })

  return ax.get(serviceURLS.GET_ETP_LIST, {
    params: paramsToSend
  })
}

export const getEtpDetails = (etpId) => {
  return ax.get(serviceURLS.GET_ETP_DETAILS.replace(':id', etpId))
}

export const findInvestors = () => {
  return ax.get(serviceURLS.FIND_INVESTORS)
}

export const getAccounts = (params) => {
  return ax.get(serviceURLS.GET_ACCOUNTS, { params })
}

export const getBalances = (accountId) => {
  return ax.get(serviceURLS.GET_BALANCES.replace(':account_id', accountId))
}

export const manualBid = (partnerId, payload) => {
  return ax.post(serviceURLS.MANUAL_BID.replace(':id', partnerId), payload)
}

export const cancelEtp = (etpId) => {
  return ax.put(serviceURLS.CANCEL_ETP.replace(':id', etpId))
}

export const defaultEtp = (etpId) => {
  return ax.put(serviceURLS.DEFAULT_ETP.replace(':id', etpId))
}

export const writeOffEtp = (etpId) => {
  return ax.put(serviceURLS.WRITE_OFF_ETP.replace(':id', etpId))
}
